import type {Comment, Thread} from '@github-ui/diff-lines/conversation-types'

export function getComments(thread: Thread): Comment[] {
  return thread.commentsData?.comments ?? []
}

/** The first comment in the thread. */
export function getInitialComment(thread: Thread): Comment | undefined {
  return getComments(thread)[0]
}

/** The most recent comment in the thread (the initial comment when there are no replies). */
export function getLatestComment(thread: Thread): Comment | undefined {
  const comments = getComments(thread)
  return comments[comments.length - 1]
}

/** The most recent comment, but only when it is a reply (i.e. not the initial comment). */
export function getLatestReply(thread: Thread): Comment | undefined {
  const comments = getComments(thread)
  return comments.length > 1 ? comments[comments.length - 1] : undefined
}
